import type { HTMLAttributes } from "react";
import { cn } from "@/lib/utils";

export function FormMessage({
  className,
  ...props
}: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p
      className={cn("mt-2 text-sm text-clay", className)}
      {...props}
    />
  );
}
